import { render, staticRenderFns } from "./ExpirySyncDateSetting.vue?vue&type=template&id=910ab452&scoped=true"
import script from "./ExpirySyncDateSetting.vue?vue&type=script&lang=js"
export * from "./ExpirySyncDateSetting.vue?vue&type=script&lang=js"
import style0 from "./ExpirySyncDateSetting.vue?vue&type=style&index=0&id=910ab452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910ab452",
  null
  
)

export default component.exports
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QToggle,QIcon,QPopupProxy,QBanner,QDialog,QCard,QCardSection,QBtn});qInstall(component, 'directives', {ClosePopup});
